import React, { createContext, useContext, useEffect, useState } from 'react'
import {User, AuthContextType } from '../interfaces/auth.insterface'
import api, { login as apiLogin, logout as apiLogout } from '../services/api';
import {getSubscribeCurrentPlan} from "../services/subcriptions";

const AuthContext = createContext<AuthContextType>({
  isAuth: false,
  user: null,
  login: async () => {},
  logout: async () => {},
  checkAuth: async () => {},
  loading: true, // Añadir estado de carga
});

export const LoginProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [user, setUser] = useState<User | null>(null);
  const [isAuth, setIsAuth] = useState(false);
  const [loading, setLoading] = useState(true); // Nuevo estado de carga

  // Verificar autenticación al cargar
  useEffect(() => {
    const verifyAuth = async () => {
      setLoading(true); // Iniciar carga
      const storedAuthToken = localStorage.getItem('authToken');
      if (storedAuthToken) {
        await checkAuth();
      } else {
        setIsAuth(false);
        setUser(null);
      }
      setLoading(false); // Finalizar carga
    };
    verifyAuth();
  }, []);

  const login = async (email: string, password: string) => {
    try {
      const response = await apiLogin(email, password);
      if (response.token) {
        localStorage.setItem('authToken', response.token);
      } else {
        localStorage.setItem('isAuth', 'true'); // Fallback si no hay token
      }
      setIsAuth(true);
      await checkAuth(); // Actualizar la información del usuario
      return response;
    } catch (error) {
      console.error('Login error:', error);
      throw error;
    }
  };

  const logout = async () => {
    try {
      await apiLogout();
    } finally {
      setUser(null);
      setIsAuth(false);
      localStorage.removeItem('authToken');
      localStorage.removeItem('isAuth');
      // window.location.href = '/login';
    }
  };

const checkAuth = async () => {
    try {
        const storedAuthToken = localStorage.getItem('authToken');
        console.log('checkAuth: storedAuthToken', storedAuthToken);
        if (storedAuthToken) {
            console.log('checkAuth: Attempting to get user data...');
            const response = await api.get('/api/get_user');
            console.log('checkAuth: get_user response', response.data);
            const sub = await getSubscribeCurrentPlan();
            console.log('checkAuth: getSubscribeCurrentPlan response', sub);
            if (response.data.user) {
                setUser({
                    email: response.data.user.email,
                    first_name: response.data.user.first_name,
                    last_name: response.data.user.last_name,
                    username: response.data.user.username,
                    subscription: sub ? sub : undefined
                });
                setIsAuth(true);
                console.log('checkAuth: User authenticated, isAuth', true);
                return response.data.user;
            }
        }
        console.log('checkAuth: No stored token or user data, setting isAuth to false');
        setUser(null);
        setIsAuth(false);
        localStorage.removeItem('authToken');
        localStorage.removeItem('isAuth');
        return null;
    } catch (error) {
        console.error('Error en checkAuth:', error);
        setUser(null);
        setIsAuth(false);
        localStorage.removeItem('authToken');
        localStorage.removeItem('isAuth');
        setLoading(false); // Finalizar carga en caso de error
        return null;
    }
};

  return (
    <AuthContext.Provider value={{ isAuth, user, login, logout, checkAuth, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);